<span>
    <input #fileinput type="file" accept="image/" capture="camera" style="display:none;" />
    <button mat-raised-button color="accent" (click)="fileinput.click()" type="button">
        <mat-icon>add_a_photo</mat-icon>
    </button>
</span>